"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaignProductsConfigSchema = exports.campaignBannerConfigSchema = void 0;
const yup_1 = require("yup");
const Yup = { string: yup_1.string, object: yup_1.object, date: yup_1.date, array: yup_1.array, number: yup_1.number };
exports.campaignBannerConfigSchema = Yup.object({
    label: Yup.string().required(),
    image: Yup.string().required(),
    desktopImage: Yup.string().nullable(),
    link: Yup.string().nullable(),
    startDate: Yup.date().required(),
    endDate: Yup.date().required(),
});
exports.campaignProductsConfigSchema = Yup.object({
    kits: Yup.array().of(Yup.number()),
    selectedProducts: Yup.array().of(Yup.number()),
});
